//src/app/features/questionnaires/create/PrepareQuestionnaire/index.tsx
import useConfirmContinue from 'app/hooks/useConfirmContinue';
import Form from 'Components/Form';
import Spinner from 'Components/Spinner';
import { useContext, useState } from 'react';
import { useSelector } from 'react-redux';
import { StepWizardChildProps } from 'react-step-wizard';
import renderInput from 'utils/renderInput';
import { CreateQuestionnaireContext } from '..';
import useCaptureInfo from '../../captureUserInfo/useCaptureInfo';
import WizardFooter from '../../components/WizardFooter';
import { getTaxReturnEstimate } from '../../edit/TaxQuestionnaire/TaxReturnEstimate';
import { selectPrepareQuestionnaire } from './slice';
import { useFields } from './useFields';
import { errorToast } from 'Components/Notifications';

export interface IPrepareQuestionnaireProps {}

export default function PrepareQuestionnaire(
  props: IPrepareQuestionnaireProps & Partial<StepWizardChildProps>,
) {
  const { nextStep, previousStep } = props;
  const confirmPrice = useConfirmContinue();
  const prepareQuestionnaire = useSelector(selectPrepareQuestionnaire);
  const individualOrBusinessFields = useFields();
  const isUserInfoCaptured = useCaptureInfo();
  const [fields, setFields] = useState(individualOrBusinessFields.fields);
  const { subscriptionLabel, isSubscribed } = useFields();
  const { submitQuestionnaire: createQuestionnaire } = useContext(
    CreateQuestionnaireContext,
  );

  const [isCreating, setIsCreating] = useState(false);

  const CreateQuestionnaireConfirmation = () => {
    if (prepareQuestionnaire.isAoaSubscriber === 'no') {
      // NEW CONDITION: For Business, if the business is subscribed to TAX, set price to 0.
      const priceEstimate = isSubscribed
        ? 0
        : getTaxReturnEstimate(prepareQuestionnaire).price;
      confirmPrice({
        onConfirm: () => {
          setIsCreating(true);
          return createQuestionnaire();
        },
        theme: 'succes',
        text: `As per the information collected this is an initial estimate, the price may vary after completing the whole questionnaire.`,
        Icon: false,
        showDefaultIcon: false,
        title: (
          <div className="flex gap-2">
            <span>Tax Return Price Estimate</span>
            <span className="text-green font-semibold">${priceEstimate}</span>
          </div>
        ),
      });
    } else {
      setIsCreating(true);
      createQuestionnaire();
    }
  };

  if (!isUserInfoCaptured || isCreating) return <Spinner />;

  return (
    <div className="h-full">
      <Form
        defaultValues={prepareQuestionnaire}
        onSubmit={CreateQuestionnaireConfirmation}
        onError={() => errorToast('Please complete all required fields.')}
        validationSchema={individualOrBusinessFields.validationSchema}
      >
        {({ handleSubmit, formState }) => (
          <div className="flex flex-col gap-6 h-full">
            <>
              {Object.keys(formState.errors).length > 0 &&
                console.log(formState.errors)}
              {/* Render subscription label if available */}
              {subscriptionLabel && (
                <div className="text-green font-semibold">
                  {subscriptionLabel}
                </div>
              )}
            </>

            <div className="md-max:mb-40">
              {fields.map((input, i) => (
                <div key={i}>{renderInput(input)}</div>
              ))}
            </div>
            <WizardFooter
              previousStep="Previous Step"
              nextStep="Tax Questionnaire"
              onPrevious={previousStep!}
              isLoading={isCreating}
            />
          </div>
        )}
      </Form>
    </div>
  );
}
